export const init = () => {
    const methodFases = document.querySelectorAll(".metodo-fases");
    if (!methodFases.length) return;

    methodFases.forEach((methodFase) => {
        const methodFasesItems = methodFase.querySelectorAll(".metodo-fase");
        if (!methodFasesItems.length) return;

        methodFasesItems.forEach((item) => {
            item.addEventListener("mouseenter", () => {
                methodFasesItems.forEach((el) => el.classList.remove("active"));
                item.classList.add("active");
            });
        });
    });
}
